import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Redirect extends React.PureComponent {

  static propTypes = {
    config: PropTypes.object,
    steps: PropTypes.array,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: null
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    this.setState({
      config: {
        ...this._getDefaults(),
        ...this.props.config || {}
      }
    })
  }

  _getDefaults() {
    return {}
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      title: 't(Redirect)',
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleDone,
      cancelSvg: 'chevron_left',
      saveText: null,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      sections: [
        {
          fields: [
            { label: 't(Destination)', name: 'destination', type: 'dropdown', placeholder: 't(Choose step)', options: this._getSteps(), required: true, defaultValue: config.destination }
          ]
        }
      ]
    }
  }

  _getSteps() {
    const { steps } = this.props
    return steps.filter(step => {
      return step.action === 'dialmenu'
    }).map(step => ({
      value: step.code,
      text: step.config.name
    }))
  }

  _handleCancel() {
    this.props.onCancel()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleDone() {
    const { config } = this.state
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

}

export default Redirect
